export { default } from './SmartFilterPane';
